import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Tooltip, Badge, Avatar, Layout, Menu, Breadcrumb, Col, Row } from 'antd';
import { Button, DatePicker, Progress, Spin, Table, Tag, Space } from 'antd';
import { Typography } from 'antd';
import { CalendarOutlined, SearchOutlined } from '@ant-design/icons';
import axios from 'axios'
const { RangePicker } = DatePicker;
const { Title } = Typography;
const { Header, Content, Footer } = Layout;


export default class ListPage extends Component{

  state = {
    data:[],
    session: {},
    domains: [
      ['BS', '기초생명의학 지식', '#13c2c2'],
      ['CD', '임상적 의사결정 능력', '#f5222d'],
      ['CSIA', '개별 동물에서의 건강과 질병 관리를 위한 임상 기술', '#5468ff'],
      ['MAH', '군집동물의 건강과 질병 관리', '#52c41a'],
      ['OHPH', '원헬스와 공중보건 전문성', '#722ed1'],
      ['SC', '학문과 연구', '#faad14'],
      ['VP', '수의전문직업성', '#a0d911'],
      ['CAC', '소통과 협력', '#37e4e4'],
    ],
    domain_count: {
      'BS':0,
      'CD':0,
      'CSIA':0,
      'MAH':0,
      'OHPH':0,
      'SC':0,
      'VP':0,
      'CAC':0,
    },
    filteredInfo: null,
    sortedInfo: null,
    dateRange: null,
    loading: true,
  }
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      ...this.state,
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };
  componentDidMount() {
    const params = new URLSearchParams(window.location.search)
    const tag = params.get('tag')
    if (tag) {
      this.setState({ filteredInfo: { ...this.state.filteredInfo, tags: [tag] } })
    }
    let records = []
    let data = []
    axios('/record/list', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
    }).then( res => {
      let records = res.data.records
      let selected_index = 0
      for (let i=0; i < records.length; i++) {
        let record = records[i]
        let dict = {
          index: i,
          primary_class: record.primary_class,
          selected_index: selected_index,
          selection:'',
          start_at: record.start_at,
          end_at: record.end_at,
          institute: record.institute,
          content: record.practice,
          tags: record.competency.split(' '),
          professor: record.professor,
          state: record.state,
          id: record.id
        }
        data.push(dict)
        selected_index += 1
        if (record.state === '승인완료') {
          let _domain_count = Object.assign(this.state.domain_count)
          for (const domain of record.competency.split(' ')) {
            _domain_count[domain] = _domain_count[domain] +  1
            this.setState({
              ...this.state,
              domain_count: this.state.domain_count
            })
          }
        }
      }
      this.setState({
        ...this.state,
        data: data,
        loading: false,
      })

    });
  }

  onDomainClick = (code) => {
    const current = (this.state.filteredInfo || {}).tags || []
    const isActive = current.length === 1 && current[0] === code
    this.setState({
      filteredInfo: {
        ...this.state.filteredInfo,
        tags: isActive ? null : [code],
      }
    })
  }

  batchList = () => {
    const activeTags = ((this.state.filteredInfo || {}).tags) || []
    return this.state.domains.map( (data) => {
      const isActive = activeTags.length === 1 && activeTags[0] === data[0]
      return (<Tooltip title={data[1]} color={data[2]} key={data[0]} visible={isActive ? true : undefined}>
        <Badge size="large" count={this.state.domain_count[data[0]]} >
              <Avatar
                onClick={() => this.onDomainClick(data[0])}
                style={{marginLeft:'30px', backgroundColor:data[2], cursor:'pointer', opacity: activeTags.length === 0 || isActive ? 1 : 0.4, transition: 'opacity 0.2s'}}
                shape="square" size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}>{data[0]}</Avatar>
      </Badge>
      </Tooltip>)
    })
  }

   onChange = (pagination, filters, sorter, extra)  => {
  }

    render(){
      if (this.state.loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}><Spin size="large" tip="로딩 중..." /></div>
      }

      // const data = [
      //   {
      //     key: '1',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '2',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '3',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      //   {
      //     key: '4',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '5',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '6',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      // ];
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const columns = [
        {
          title: '실습 분류',
          dataIndex: 'primary_class',
          key: 'primary_class',
          sorter: (a, b) => (a.primary_class || '').localeCompare(b.primary_class || ''),
          sortOrder: sortedInfo.columnKey === 'primary_class' && sortedInfo.order,
          filters: [...new Set(this.state.data.map(d => d.primary_class).filter(Boolean))].sort()
            .map(v => ({ text: v, value: v })),
          filteredValue: filteredInfo.primary_class || null,
          onFilter: (value, record) => record.primary_class === value,
        },
        {
          title: '실습 날짜',
          dataIndex: 'selected_index',
          key: 'date',
          render: (index) =>
          this.state.data[index] ? <Link to={`/detail/${this.state.data[index].id}`} >{
            (new Date(this.state.data[index].start_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})
          } ~ {
            (new Date(this.state.data[index].end_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})
          }</Link> : '',
          sorter: (a, b) => new Date(a.start_at) - new Date(b.start_at),
          sortOrder: sortedInfo.columnKey === 'date' && sortedInfo.order,
          filterDropdown: ({ setSelectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
              <RangePicker
                value={this.state.dateRange}
                onChange={(dates) => {
                  this.setState({ dateRange: dates })
                  setSelectedKeys(dates ? [dates] : [])
                }}
                style={{ marginBottom: 8, display: 'block' }}
              />
              <Space>
                <Button type="primary" size="small" icon={<SearchOutlined />}
                  onClick={() => confirm()}>
                  검색
                </Button>
                <Button size="small" onClick={() => {
                  this.setState({ dateRange: null })
                  clearFilters()
                  confirm()
                }}>
                  초기화
                </Button>
              </Space>
            </div>
          ),
          filterIcon: () => <CalendarOutlined style={{ color: this.state.dateRange ? '#1890ff' : undefined }} />,
        },
        {
          title: '실습 기관',
          dataIndex: 'institute',
          key: 'institute',
          sorter: (a, b) => (a.institute || '').localeCompare(b.institute || ''),
          sortOrder: sortedInfo.columnKey === 'institute' && sortedInfo.order,
        },
        {
          title: '실습 내용',
          dataIndex: 'content',
          key: 'content',
        },
        {
          title: '졸업 역량',
          key: 'tags',
          dataIndex: 'tags',
          filters: this.state.domains.map(([code, name, color]) => ({
            text: <span><span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', backgroundColor: color, marginRight: 6 }} />{code} - {name}</span>,
            value: code,
          })),
          filteredValue: filteredInfo.tags || null,
          render: tags => (
            <>
              {tags.map(tag => {
                const domain = this.state.domains.find(d => d[0] === tag)
                const color = domain ? domain[2] : (tag.length > 5 ? 'geekblue' : 'green')
                return (
                  <Tag color={color} key={tag}>
                    {tag.toUpperCase()}
                  </Tag>
                );
              })}
            </>
          ),
        },
        {
          title: '승인 상태',
          dataIndex:'state',
          key: 'state',
          sorter: (a, b) => (a.state || '').localeCompare(b.state || ''),
          sortOrder: sortedInfo.columnKey === 'state' && sortedInfo.order,
          filters: [
            { text: '승인완료', value: '승인완료' },
            { text: '승인대기', value: '승인대기' },
            { text: '반려', value: '반려' },
          ],
          onFilter: (value, record) => record.state === value,
          filteredValue: filteredInfo.state || null,
        },
      ];
      // for (let i=0; i < records.length, i++;) {
      //   console.log(i)
      // } 
      // const data = [
      //   {
      //     key: '1',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '2',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '3',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      //   {
      //     key: '4',
      //     date: '2021/03/25',
      //     institute: '서울대학교 동물병원',
      //     content: '고양이 암컷 중성화',
      //     tags: ['GS', ],
      //     professor: '홍길동 교수',
      //     state: '승인 완료',
      //   },
      //   {
      //     key: '5',
      //     date: '2021/04/01',
      //     institute: '본동물의료센터1',
      //     content: '신경계검사 수행',
      //     tags: ['IM', 'ER'],
      //     professor: '홍길동 교수',
      //     state: '승인 대기',
      //   },
      //   {
      //     key: '6',
      //     date: '2021/04/05',
      //     institute: '국군의학연구소4',
      //     content: '의학연구소 연구인턴',
      //     tags: ['Research', 'Medical'],
      //     professor: '홍길동 교수',
      //     state: '승인 반려',
      //   },
      // ];


      return (
          // <Row style={{  margin:'50px'}}>
          <>
          <Col  xs={{span:22, offset:1}}  
            sm={{span:20, offset:2}} 
            md={{span:20, offset:2}} 
            lg={{span:20, offset:2}} 
            xxl={{span:16, offset:4}} 

            style={{marginTop:'40px', }}
            // xl={{span:20, offset:2}} 
            // xxl={{span:20, offset:2}} 
           >




          <Row>
            <Col span={24}>
              <Row>
                <Col>
                <Title level={3}>졸업 역량 별 포트폴리오 현황</Title>
                </Col>
              </Row>
              <Row wrap={false}>
                {this.batchList()}
                {/* <Progress format={() => { return (<b>Clinical Reasoning & Decision-making</b>)}}  percent={80}  state="active" strokeColor='blue' />
                <Progress format={() => { return (<b>Individual Animal Care and Management</b>)}}  percent={40}  state="active" strokeColor='sky' />
                <Progress format={() => { return (<b>Animal Population Care and Management</b>)}}  percent={55}  state="active" strokeColor='#005666' />
                <Progress format={() => { return (<b>Public Health</b>)}}  percent={32}  state="active" strokeColor='green' />
                <Progress format={() => { return (<b>Communication</b>)}}  percent={73}  state="active" strokeColor='#5CD453	' />
                <Progress format={() => { return (<b>Collaboration</b>)}}  percent={90}  state="active" strokeColor='#F4D74F' />
                <Progress format={() => { return (<b>Professionalism and Professional Identity</b>)}}  percent={60}  state="active" strokeColor='#FFC681	' />
                <Progress format={() => { return (<b>Financial and Practice Management</b>)}}  percent={30}  state="active" strokeColor='orange' />
                <Progress format={() => { return (<b>Scholarship</b>)}}  percent={20}  state="active" strokeColor='#E00546	' /> */}
              </Row>
            </Col>
          </Row>
          <br></br>
          <br></br>

              {/* <TestPage hi='' ></TestPage> */}
            <Row span={12}>
              <Col>
                <Title level={3}>포트폴리오 리스트</Title>
              </Col>
              <Col offset={19} span={1}>
                <Link to='create'><Button level={3} >+ 실습 추가</Button></Link>
              </Col>
            </Row>
            <Row span={12}>
              <Col span={24}>
                <Table columns={columns} dataSource={
                  this.state.data.filter(record => {
                    if (filteredInfo.tags && filteredInfo.tags.length > 0) {
                      if (!filteredInfo.tags.every(tag => record.tags.includes(tag))) return false
                    }
                    if (this.state.dateRange && this.state.dateRange[0] && this.state.dateRange[1]) {
                      const start = new Date(record.start_at)
                      const end = new Date(record.end_at)
                      const rangeStart = this.state.dateRange[0].startOf('day').toDate()
                      const rangeEnd = this.state.dateRange[1].endOf('day').toDate()
                      if (end < rangeStart || start > rangeEnd) return false
                    }
                    return true
                  })
                } onChange={this.handleChange} />
              </Col>
            </Row>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>this.state.number</Breadcrumb.Item>
              <Breadcrumb.Item><DisplayNumber/></Breadcrumb.Item>
              <Breadcrumb.Item>List</Breadcrumb.Item>
              <Breadcrumb.Item>App</Breadcrumb.Item>
            </Breadcrumb> */}
            {/* <div className="site-layout-content">Content</div>
            <div className="site-layout-content"><DisplayNumber/></div> */}
          {/* </Row> */}

        </Col>
          </>
        )
    }
}